import { POST_LOGOUT } from '@/dataSource/api/user/apiAuth'
import { removeItemIndexdDB } from '@/dataSource/indexed-DB/indexedDB'
import router from '@/router'
import { defineStore } from 'pinia'

interface TypeLogout {
    resultLogout: any
    loading: boolean
}

export const Logout = defineStore('Logout', {
    state: () => <TypeLogout>({
        resultLogout: [],
        loading: false
    }),
    actions: {
        async UserLogout() {
            this.loading = true
            await removeItemIndexdDB('token')
            await removeItemIndexdDB('profile')
            router.push({ name: 'EnterNumberPage' })
            this.resultLogout = await POST_LOGOUT()
            this.loading = false
            window.location.reload()
        }
    }
})